import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class FaviconService {
  private readonly mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

  constructor() {
    // listen to browser theme changes
    this.mediaQuery.addEventListener("change", e => {
      this.updateFavicon(e.matches);
    });

    // initial setup using browser preference
    this.updateFavicon(this.mediaQuery.matches);
  }

  private updateFavicon(isDark: boolean): void {
    const fullUrl = window.location.href.toLowerCase();
    const isYachtDrop = fullUrl.includes("yachtdrop");

    const faviconPath = isYachtDrop
      ? isDark
        ? "assets/images/yachtdrop-logo-white.svg"
        : "assets/images/yachtdrop-logo-black.svg"
      : isDark
        ? "assets/images/villadrop-logo-white.svg"
        : "assets/images/villadrop-logo-black.svg";

    let linkElement = document.querySelector<HTMLLinkElement>("link[rel*='icon']");

    if (!linkElement) {
      linkElement = document.createElement("link");
      document.head.appendChild(linkElement);
    }

    linkElement.type = "image/x-icon";
    linkElement.rel = "shortcut icon";
    linkElement.href = faviconPath;
  }
}
